import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  giftCards: {},
  selectedGiftCardId: "",
  validateGiftCodeData:{}
};

const giftCards = produce((draft = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case Actions.GET_GIFT_CARDS_LIST: {
      draft.giftCards = payload?.giftCards;
      break;
    }
    case Actions.SELECTED_GIFT_CARD_ID: {
      draft.selectedGiftCardId = payload?.selectedGiftCardId;
      break;
    }

    case Actions.GET_VALIDATE_GIFT_CODE: {
      draft.validateGiftCodeData = payload?.validateGiftCodeData;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default giftCards;
